module.exports = __webpack_public_path__ + "img/undraw_inspiration_lecl.50704fe6.svg";